export default __webpack_public_path__ + "static/media/detailed-information-icon.df852a20.svg";